import React, { useEffect, useState } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import Swal from "sweetalert2";
import { useNavigate } from 'react-router-dom';

const formatPrice = (price) => {
    const num = parseInt(price, 10);
    if (isNaN(num)) return "Invalid Price";

    if (num >= 10000000) {
        // Convert to Crores
        return `${(num / 10000000).toFixed(2)} Cr`;
    } else if (num >= 100000) {
        // Convert to Lakhs
        return `${(num / 100000).toFixed(2)} L`;
    } else if (num >= 1000) {
        // Convert to Thousands
        return `${(num / 1000).toFixed(2)} K`;
    } else {
        // For amounts less than 1000
        return num.toString();
    }
};

const MyProperty = () => {
    const { isSidebarOpen } = useSidebar();
    const [data, setData] = useState([]);
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // You can adjust this as needed


    const fetchData = async () => {
        try {
            const response = await fetch(`https://100billionoms.com/property/getproperty/${isLoggedIn.user_id}`);
            const res = await response.json();

            const parseJSON = (data) => {
                try {
                    return JSON.parse(data);
                } catch {
                    return data; // Return original data if parsing fails
                }
            };

            // Parse and clean up the data
            const parsedData = res.map((item) => ({
                ...item,
                amenities: parseJSON(item.amenities || "[]"),
                carpetArea: parseJSON(item.carpetArea || "[]"),
                flatType: parseJSON(item.flatType || "[]"),
                formImages: parseJSON(item.formImages || "[]"),
                locationAdvantages: parseJSON(item.locationAdvantages || "[]"),
            }));
            setData(parsedData.reverse());
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleDelete = async (id) => {
        // Show SweetAlert confirmation
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "This action will delete the property permanently!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        });

        if (result.isConfirmed) {
            try {
                // Simulate a delete request to the server
                await fetch(`https://100billionoms.com/property/delete-store/${id}`, {
                    method: "DELETE",
                });
                fetchData();
                // Remove property from the UI
                // setData((prevData) => prevData.filter((_, i) => i !== id));

                // Show success message
                Swal.fire("Deleted!", "The property has been deleted.", "success");
            } catch (error) {
                console.error("Error deleting property:", error);
                Swal.fire("Error!", "Failed to delete the property. Try again later.", "error");
            }
        }
    };

    useEffect(() => {
        fetchData();
    }, []);
    console.log(data)
    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="property-table-container">
                    <h2>Property Details Table</h2>
                    <div className="property-tab">
                        <table className="property-table">
                            <thead>
                                <tr>
                                    <th>Actions</th>
                                    <th>Project Name</th>
                                    <th>Address</th>
                                    {/* <th>Price (₹)</th> */}
                                    <th>Amenities</th>
                                    {/* <th>Bedrooms</th>
                            <th>Bathrooms</th>
                            <th>Balconies</th> */}
                                    <th>Total Floors</th>
                                    <th>Floor Level</th>
                                    <th>Availability</th>
                                    <th>Age of Building (Years)</th>
                                    <th>Ownership</th>
                                    <th>Facing</th>
                                    {/* <th>Maintenance (₹)</th> */}
                                    <th>Parking</th>
                                    <th>Security Deposit (₹)</th>
                                    <th>Location Advantages</th>
                                    <th>Flat Type</th>
                                    <th>Carpet Area (sq ft)</th>
                                    <th>Expected Price (₹)</th>

                                </tr>
                            </thead>
                            <tbody>
                                {data.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((property, index) => {
                                    const validFlatTypes = (property.flatType || []).filter((flat) =>
                                        flat.builtUpAreas?.some((area) => area.value)
                                    );

                                    return (
                                        <React.Fragment key={index}>
                                            {validFlatTypes.length > 0 ? (
                                                validFlatTypes.map((flat, flatIndex) => (
                                                    <tr key={`${index}-${flatIndex}`}>
                                                        {flatIndex === 0 && (
                                                            <>
                                                                <td rowSpan={validFlatTypes.length}>
                                                                    <div style={{ display: "flex", gap: "10px" }}>
                                                                        <button
                                                                            style={{ color: "white", background: "#3152F4", border: "none", padding: "7px", borderRadius: "5px" }}
                                                                            // onClick={() => handleDelete(property.id)}
                                                                            onClick={() => navigate(`/property-form/${property.property_id}`)}
                                                                        >
                                                                            <i class="fa-solid fa-pen"></i>
                                                                        </button>
                                                                        <button
                                                                            style={{ color: "white", background: "red", border: "none", padding: "7px", borderRadius: "5px" }}
                                                                            onClick={() => handleDelete(property.id, property.property)}
                                                                        >
                                                                            <i className="fa fa-trash" />
                                                                        </button>
                                                                    </div>

                                                                </td>
                                                                <td rowSpan={validFlatTypes.length}>
                                                                    {property.building_name || "-"}
                                                                </td>
                                                                <td rowSpan={validFlatTypes.length}>
                                                                    {property.address || "-"}
                                                                </td>
                                                                {/* <td rowSpan={validFlatTypes.length}>
                                                            {property.price || "-"}
                                                        </td> */}
                                                                <td rowSpan={validFlatTypes.length}>
                                                                    {(property.amenities || []).length > 4
                                                                        ? property.amenities.slice(0, 4).join(", ") + "..."
                                                                        : (property.amenities || []).join(", ") || "-"
                                                                    }

                                                                </td>
                                                                {/* <td rowSpan={validFlatTypes.length}>
                                                            {property.bedrooms || "-"}
                                                        </td>
                                                        <td rowSpan={validFlatTypes.length}>
                                                            {property.bathrooms || "-"}
                                                        </td>
                                                        <td rowSpan={validFlatTypes.length}>
                                                            {property.balconies || "-"}
                                                        </td> */}
                                                                <td rowSpan={validFlatTypes.length}>
                                                                    {property.totalFloors || "-"}
                                                                </td>
                                                                <td rowSpan={validFlatTypes.length}>
                                                                    {property.floorLevel || "-"}
                                                                </td>
                                                                <td rowSpan={validFlatTypes.length}>
                                                                    {property.availabilityStatus || "-"}
                                                                </td>
                                                                <td rowSpan={validFlatTypes.length}>
                                                                    {property.ageOfBuilding || "-"}
                                                                </td>
                                                                <td rowSpan={validFlatTypes.length}>
                                                                    {property.ownership || "-"}
                                                                </td>
                                                                <td rowSpan={validFlatTypes.length}>
                                                                    {property.facing || "-"}
                                                                </td>
                                                                {/* <td rowSpan={validFlatTypes.length}>
                                                            {formatPrice(property.maintenance) || "-"}
                                                        </td> */}
                                                                <td rowSpan={validFlatTypes.length}>
                                                                    {property.parking || "-"}
                                                                </td>
                                                                <td rowSpan={validFlatTypes.length}>
                                                                    {formatPrice(property.securityDeposit) || "-"}
                                                                </td>
                                                                <td rowSpan={validFlatTypes.length}>
                                                                    {(property.locationAdvantages || []).length > 4
                                                                        ? property.locationAdvantages.slice(0, 4).join(", ") + "..."
                                                                        : (property.locationAdvantages || []).join(", ") || "-"
                                                                    }

                                                                </td>
                                                            </>
                                                        )}
                                                        <td>{flat.type || "-"}</td>
                                                        <td>
                                                            {flat.builtUpAreas
                                                                .filter((area) => area.value)
                                                                .map((area) => area.value)
                                                                .join(", ") || "-"}
                                                        </td>
                                                        <td>
                                                            {flat.builtUpAreas
                                                                .filter((area) => formatPrice(area.expectedPrice))
                                                                .map((area) => formatPrice(area.expectedPrice))
                                                                .join(", ") || "-"}
                                                        </td>

                                                    </tr>
                                                ))
                                            ) : (
                                                null
                                            )}
                                        </React.Fragment>
                                    );
                                })}
                            </tbody>
                        </table>
                        <div className="pagination-container">
                            <button
                                className="pagination-button"
                                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                disabled={currentPage === 1}
                            >
                                ◀ Prev
                            </button>

                            <span className="pagination-current">
                                Page {currentPage} of {Math.ceil(data.length / itemsPerPage)}
                            </span>

                            <button
                                className="pagination-button"
                                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, Math.ceil(data.length / itemsPerPage)))}
                                disabled={currentPage === Math.ceil(data.length / itemsPerPage)}
                            >
                                Next ▶
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default MyProperty;
